<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Coupons",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Coupons",
            items: [
               {
                  text: "Coupons",
                  active: true,
               },                   
            ],

            
            coupon_type:"",

            coupons: [],
            coupon: {
               id: null,
                name : "",
                  code: "",
                  type: 0,
                  amount: '',
                  percentage: '',
                  count: "",
                  expiry_date: "",
                  min_order_amount: "",
               },
               coupon_status: {
               id: "",
               status: "",
            },
            modal_title: "Add Coupon",
            button_title: "Save",
            pagination: {},
            edit: false,
           
            listing_length: 10,
            keyword: '',
            status: '',
            token: "",
            errors: {},
            activate: false,
            deactivate: false,

            active_page_url: null,
         };
      },
      mounted() {
    
      },
      created() {
         this.fetchCoupons();
      },


      methods: {
         fetchCoupons(page_url = null) {

            this.getToken();
            let url = "api/admin/coupons?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;

            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.coupons = responseData.coupons.data;
                  
                  this.pagination = responseData.coupons.links;
                  this.from = responseData.coupons.from;
                  this.to = responseData.coupons.to;
                  this.total = responseData.coupons.total;
               
            })
            .catch((error) => {
         console.log(error);
         console.log(error.response);
         if (error.response) {
            if(error.response.status == 422) {               
               if (error.response.data) {
                  this.errors = error.response.data.message;
               } 
               this.$swal("", error.response.statusText, "error");
               
            } else if(error.response.status == 500) {
               this.$swal("", error.response.statusText, "error");
            } 
            else if(error.response.status == 401) {
               this.$swal("", error.response.statusText, "error");
               this.$router.push({ name: "login" });
            } else {
               this.$swal("", "Something went wrong", "error");
            }
         } else {
            this.$swal("", error.message, "error");
         }

         });
         //.finally(() => (this.loading = false));
         },
            getToken() 
            {
            if (localStorage.getItem('sigofuel_admin')) 
                  {
                     var sigofuel_admin =  JSON.parse(localStorage.getItem('sigofuel_admin'));
                     if(sigofuel_admin.token) {
                        this.token = sigofuel_admin.token;
                        } else {
                              this.$swal("", "Failed to fetch token, please login again", "error");
                              this.$router.push({ name: "login" });
                              }
                  
                     } else {
                           this.$swal("", "Session expired, please login again", "error");
                           this.$router.push({ name: "login" });
                           }
            },
            activateCoupon(coupon) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to publish this Coupon?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                  this.coupon_status.id = coupon.id;
                  this.coupon_status.status = 1;
                  this.updateCouponStatus();
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },
         deactivateCoupon(coupon) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this Coupon?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value => {
                  this.deactivate = value
                  if(this.deactivate){
                  this.coupon_status.id = coupon.id;
                  this.coupon_status.status = 2;
                  this.updateCouponStatus();
               }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         updateCouponStatus() {
            
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };     

            // var data = JSON.stringify({
            //    "id": this.coupon_status.id,
            //    "status": this.coupon_status.status
            // });

            let url = "api/admin/coupon/status?id=" + this.coupon_status.id + "&status=" + this.coupon_status.status;
            this.$axios
               .get(url,config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchCoupons(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         },
         setCode() {
            var str = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            this.coupon.coupon_code = Array(10).fill(str).map(function(x) { return x[Math.floor(Math.random() * x.length)] }).join('');
            this.showModal("coupon-modal");
         },
         addCoupon() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url;
            let formData = new FormData();

            if(!this.edit) {
               url = "api/admin/coupon/add";
               this.active_page_url = null;

            } else {
               url = "api/admin/coupon/edit";
               formData.append("id", this.coupon.id); 
            }         

            formData.append("coupon_name", this.coupon.coupon_name); 
            formData.append("coupon_code", this.coupon.coupon_code); 
            formData.append("type", this.coupon.type); 
            // formData.append("coupon_for", this.coupon.coupon_for); 
            
            
            formData.append("count", this.coupon.count); 
            formData.append("expiry_date", this.coupon.expiry_date); 
            formData.append("min_order_amount", this.coupon.min_order_amount);

            if(this.coupon.type == 1 || this.coupon.type == 3) {
               formData.append("amount", this.coupon.amount); 
            } else {
               formData.append("percentage", this.coupon.amount); 
            }

         
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('coupon-modal');
                  this.fetchCoupons(this.active_page_url);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
         
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         editCoupon(coupon) {          
            this.modal_title = "Edit Coupon";
            this.button_title = "Update";
            this.coupon.id = coupon.id;
            this.coupon.coupon_name = coupon.coupon_name;
            this.coupon.coupon_code = coupon.coupon_code;
            this.coupon.type = coupon.type;
            // this.coupon.coupon_for = coupon.coupon_for;
            this.coupon.amount = coupon.amount;
            this.coupon.count = coupon.count;
            this.coupon.expiry_date = coupon.expiry_date;
            this.coupon.min_order_amount = coupon.min_order_amount;
            this.edit = true;
            this.showModal("coupon-modal");
         },
         clearForm() {           
            
            this.modal_title = "Add Coupon";
            this.button_title = "Add";
            this.coupon.coupon_name = "";
            this.coupon.coupon_code = "";
            this.coupon.type = 0;
            this.coupon.amount = '';
            this.coupon.percentage = '';
            this.coupon.count = "";
            this.coupon.expiry_date = "";
            this.coupon.min_order_amount = "";
            this.edit = false;
            this.errors = {};
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <b-button v-b-modal.coupon-modal variant="primary" class="float-end"  @click="setCode()">Add Coupon</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length"  @change="fetchCoupons()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchCoupons()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change="fetchCoupons()">
                                 <option value="">All</option>
                                 <option value="1">Published</option>
                                 <option value="2">Unpublished</option>
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                               
                           <tr>
                              <th>Name</th>  
                              <th>Code</th> 
                              <th>Type</th> 
                              <th>Amount/<br>Percentage</th>
                              <th>Count</th>
                              <th>Min Order Amount</th> 
                              <th>Expiry</th>    
                              <th>Status</th>
                              <th>Created on</th>
                              <th width="10%">Options</th>                             
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(coupons.length)">
                           <tr  v-for="(coupon) in coupons" :key="coupon.id">
                              <td>{{coupon.coupon_name}}</td>
                              <td>{{coupon.coupon_code}}</td>
                              <td>
                                 <span v-if="coupon.type==1">Amount</span>
                                 <span v-if="coupon.type==2">Percentage</span>
                                 <span v-if="coupon.type==3">Amount For Additional Fuel</span>
                              </td>
                              <td>
                                 <span v-if="coupon.type==1">Rs. {{coupon.amount}}</span>
                                 <span v-if="coupon.type==2">{{coupon.amount}}%</span>
                                 <span v-if="coupon.type==3">Rs. {{coupon.amount}}</span>

                              </td>
                              <td>{{coupon.count}}</td>
                              <td>{{coupon.min_order_amount}}</td>
                              <td>{{coupon.expiry_date | formatDateTime}}</td>
                              <td>
                                 <span class="badge rounded-pill bg-success" v-if="coupon.status==1">Active</span>
                                 <span class="badge rounded-pill bg-danger" v-if="coupon.status==2">Blocked</span>

                              </td>
                              <td>{{coupon.converted_created_at}}</td>
                              <td>
                                 <b-button variant="primary" class="btn-sm me-2 mb-2" @click="editCoupon(coupon)">Edit</b-button>                         
                                 <b-button v-if="coupon.status==1" variant="danger" class="btn-sm mt-2 me-2" @click="deactivateCoupon(coupon)">Unpublish</b-button>
                                 <b-button v-else variant="success" class="btn-sm mt-2 me-2" @click="activateCoupon(coupon)">Publish</b-button>                              </td>
                           </tr>
                 
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(coupons.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchCoupons(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                  
                  <!---- modal starts ---->
                  <b-modal ref="coupon-modal" id="coupon-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="addCoupon()">
                        <b-row>
                           <b-col md="12" class="form-group">
                              <label class="control-label">Coupon Name<span class="text-danger">*</span></label>
                              <b-form-input v-model="coupon.coupon_name" v-bind:class="{ 'is-invalid': Boolean(errors.coupon_name) }"></b-form-input>
                              <div v-for="(val, index) in errors.coupon_name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col> 


                           <b-col md="12" class="form-group">
                              <label class="control-label">Type<span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="coupon.type" v-bind:class="{ 'is-invalid': Boolean(errors.type) }">
                                 <div class="form-check-inline">
                                    <b-form-radio :name="coupon_type"  :value="1">Amount (Off) </b-form-radio> 
                                 </div>
                                 <div class="form-check-inline"> 
                                    <b-form-radio :name="coupon_type" :value="2">Percentage (Off)</b-form-radio>
                                 </div>
                                 <!-- <div class="form-check-inline">
                                    <b-form-radio :name="coupon_type"  :value="3">Amount for Additional Fuel</b-form-radio> 
                                 </div> -->
                              </b-form-radio-group>
                              <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" class="form-group">
                              <label class="control-label">Code<span class="text-danger">*</span></label>
                              <b-form-input v-model="coupon.coupon_code" v-bind:class="{ 'is-invalid': Boolean(errors.coupon_code) }" disabled></b-form-input>
                              <div v-for="(val, index) in errors.coupon_code" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           <b-col md="6" class="form-group" v-if="coupon.type==1 || coupon.type==2 || coupon.type==3">
                              <label v-if="coupon.type==1 || coupon.type==3 " class="control-label">Amount (in Rs)<span class="text-danger">*</span></label>
                              <label v-else class="control-label">Percentage<span class="text-danger">*</span></label>
                              <b-form-input v-model="coupon.amount" v-bind:class="{ 'is-invalid': Boolean(errors.amount) || Boolean(errors.percentage) }"></b-form-input>

                              <div v-for="(val, index) in errors.amount" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>

                              <div v-for="(val, index) in errors.percentage" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           <!-- <b-col md="6" class="form-group" v-if="coupon.type==1">
                              <label class="control-label">Amount (in $)<span class="text-danger">*</span></label>
                              <b-form-input v-model="coupon.amount" v-bind:class="{ 'is-invalid': Boolean(errors.amount) }"></b-form-input>
                              <div v-for="(val, index) in errors.amount" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" class="form-group" v-if="coupon.type==2">
                              <label class="control-label">Percentage<span class="text-danger">*</span></label>
                              <b-form-input v-model="coupon.percentage" v-bind:class="{ 'is-invalid': Boolean(errors.percentage) }"></b-form-input>
                              <div v-for="(val, index) in errors.percentage" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col> -->

                           <b-col md="6" class="form-group">
                              <label class="control-label">Count<span class="text-danger">*</span></label>
                              <b-form-input v-model="coupon.count" v-bind:class="{ 'is-invalid': Boolean(errors.count) }"></b-form-input>
                              <div v-for="(val, index) in errors.count" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" class="form-group">
                              <label class="control-label">Expiry<span class="text-danger">*</span></label>
                              <!-- <b-form-datepicker v-model="coupon.expiry" v-bind:class="{ 'is-invalid': Boolean(errors.expiry) }"></b-form-datepicker> -->
                              <input type="date" class="form-control" v-model="coupon.expiry_date" v-bind:class="{ 'is-invalid': Boolean(errors.expiry_date) }"/>
                              <div v-for="(val, index) in errors.expiry_date" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" class="form-group">
                              <label class="control-label">Minimum Order Amount<span class="text-danger">*</span></label>
                              <b-form-input v-model="coupon.min_order_amount" v-bind:class="{ 'is-invalid': Boolean(errors.min_order_amount) }"></b-form-input>
                              <div v-for="(val, index) in errors.min_order_amount" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           
                           <b-col md="12">
                              <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                              <b-button class="" variant="light" @click="hideModal('coupon-modal')">Close</b-button>
                           </b-col>
                        </b-row>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
